module.exports = __webpack_public_path__ + "static/media/overview7_1.4301d84b.png";